<div>
    <div class="row">
        <div class="col col-1">
            <p><b>Kantoor</b></p>
        </div>
        <div class="col-2">
        </div>
        <div class="col-3">
        </div>
    </div>
</div>
<form [formGroup]="dienstverlenerFg">
    <div>
        <snelstart-ui-text-form-control formControlName="naamDienstverlener"
                                        id="naamDienstverlener"
                                        label="Kantoornaam"
                                        class="custom-input-250"
                                        [disabledControl]="true"
                                        (change)="saveForm()"
        >
        </snelstart-ui-text-form-control>
    </div>
  <div>
    <snelstart-ui-text-form-control formControlName="rsinDienstverlener"
                                    id="beconNummer"
                                    label="Kantoor fiscaal nummer"
                                    class="custom-input-250"
                                    [disabledControl]="true"
                                    (change)="saveForm()"
    >
    </snelstart-ui-text-form-control>
  </div>
  <div>
    <snelstart-ui-text-form-control formControlName="beconNummer"
                                    id="beconNummer"
                                    label="Beconnummer"
                                    class="custom-input-250"
                                    [disabledControl]="true"
                                    (change)="saveForm()"
    >
    </snelstart-ui-text-form-control>
  </div>
</form>
<div>
    <div class="row pt-3">
        <div class="col col-1">
            <p><b>Contactpersoon</b></p>
        </div>
        <div class="col-2">
        </div>
        <div class="col-3">
        </div>
    </div>
</div>
<form [formGroup]="contactFg">
  <div class="row">
    <div class="col-auto">
      <snelstart-ui-text-form-control formControlName="voorletters"
                                      id="voorletters"
                                      label="Voorletter(s)"
                                      class="custom-input-125"
                                      (change)="saveForm()"
      >
      </snelstart-ui-text-form-control>
    </div>
    <div class="col-auto">
      <snelstart-ui-text-form-control formControlName="tussenvoegsel"
                                      id="tussenvoegsel"
                                      label="Tussenvoegsel"
                                      class="custom-input-100"
                                      (change)="saveForm()"
      >
      </snelstart-ui-text-form-control>
    </div>
  </div>
  <div>
    <snelstart-ui-text-form-control formControlName="achternaam"
                                    id="achternaam"
                                    label="Achternaam"
                                    class="custom-input-250"
                                    (change)="saveForm()"
    >
    </snelstart-ui-text-form-control>
  </div>
  <div>
    <snelstart-ui-email-form-control formControlName="emailadres"
                                     id="emailadres"
                                     label="E-mailadres"
                                     class="custom-input-250"
                                     (change)="saveForm()"
    >
    </snelstart-ui-email-form-control>
  </div>
  <div>
    <snelstart-ui-text-form-control formControlName="telefoonnummer"
                                     id="telefoonnummer"
                                     label="Telefoonnummer"
                                     class="custom-input-250"
                                     (change)="saveForm()"
    >
    </snelstart-ui-text-form-control>
  </div>
</form>
